// extracted by mini-css-extract-plugin
export default {"title":"GetFeedback_title__C+B3-","boxForm":"GetFeedback_boxForm__NHvFe","form":"GetFeedback_form__WVcvz"};